import React from "react"
import types from "prop-types"
import {
  activityHubSurveyDetailsCopy, activityHubRemindersCopy, commentCopy,
} from "utils/surveyTokenPublicDetailsHelpers"
import { surveyTokenPublicDetailsShape } from "utils/propTypeShapes"
import ContentBar from "shared/lists/ContentBar"

const SurveyTokenPublicDetails = ({ className = "", surveyDetails }) => {
  const { surveyBatchAnonymous } = surveyDetails

  const showComment = !surveyBatchAnonymous
  const showReminderCCEmail = !surveyBatchAnonymous

  return (
    <div className={className}>
      <ContentBar
        title="Details"
        description={activityHubSurveyDetailsCopy(surveyDetails)}
      />
      {
        showComment && (
          <ContentBar
            title="Additional Context"
            description={commentCopy(surveyDetails)}
          />
        )
      }
      {
        showReminderCCEmail && (
          <ContentBar
            title="Reminders"
            description={activityHubRemindersCopy(surveyDetails)}
          />
        )
      }
    </div>
  )
}

SurveyTokenPublicDetails.propTypes = {
  className: types.string,
  surveyDetails: surveyTokenPublicDetailsShape.isRequired,
}

export default SurveyTokenPublicDetails
